export default "__VITE_ASSET__b352d802__"